import { Sun, Users, Sparkles } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/Reveal";

const icons = [Sun, Users, Sparkles];

export const WhatIsSummit = () => {
  const { t } = useLanguage();
  const w = t.whatIs;
  const parts = w.title.split(".").map((s) => s.trim()).filter(Boolean);

  return (
    <section className="relative py-24 md:py-32 bg-[#010E3A] border-y border-white/5">
      <div className="container-page">
        <Reveal className="max-w-3xl">
          <span className="overline text-[#CEA26B]">{w.overline}</span>
          <h2 className="mt-4 font-display font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl leading-tight">
            {w.title}
          </h2>
        </Reveal>

        <div className="mt-10 grid sm:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {parts.map((part, i) => {
            const Icon = icons[i] || Sparkles;
            return (
              <Reveal key={i} delay={0.06 * i} className="bg-[#010E3A]">
                <div className="p-7 h-full flex items-center gap-3" data-testid={`whatis-part-${i}`}>
                  <Icon className="h-6 w-6 text-[#CEA26B] shrink-0" />
                  <span className="font-display font-semibold text-white">{part}.</span>
                </div>
              </Reveal>
            );
          })}
        </div>

        <div className="mt-12 grid lg:grid-cols-2 gap-8 max-w-5xl">
          {w.paragraphs.map((p, i) => (
            <Reveal key={i} delay={0.08 * i}>
              <p className="text-base md:text-lg text-slate-300 leading-relaxed">{p}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
